package fr.manyverse.app.presentation.components.onboarding

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import fr.manyverse.app.presentation.components.clearFocusOnTap
import fr.manyverse.app.presentation.viewmodel.AuthUiState
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.cancel
import manyverse.shared.generated.resources.email
import manyverse.shared.generated.resources.error_invalid_email
import manyverse.shared.generated.resources.send
import manyverse.shared.generated.resources.sign_in_with_otp
import org.jetbrains.compose.resources.stringResource

@Composable
fun EmailSignInDialog(
    uiState: AuthUiState,
    onEmailChange: (String) -> Unit,
    onSendOtp: () -> Unit,
    onDismiss: () -> Unit
) {
    val focusRequester = remember { FocusRequester() }
    LaunchedEffect(Unit) {
        focusRequester.requestFocus()
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(dismissOnBackPress = false, dismissOnClickOutside = false),
        modifier = Modifier.imePadding().clearFocusOnTap(),
        title = { Text(stringResource(Res.string.sign_in_with_otp)) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                OutlinedTextField(
                    value = uiState.email,
                    onValueChange = onEmailChange,
                    label = { Text(stringResource(Res.string.email)) },
                    modifier = Modifier
                        .fillMaxWidth()
                        .testTag("emailDialogField")
                        .focusRequester(focusRequester),
                    singleLine = true,
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Email,
                        imeAction = ImeAction.Send
                    ),
                    keyboardActions = KeyboardActions(
                        onSend = {
                            if (!uiState.isLoading && uiState.email.isNotBlank()) {
                                onSendOtp()
                            }
                        }
                    ),
                    isError = uiState.isEmailValid == false,
                    supportingText = {
                        if (uiState.isEmailValid == false) {
                            Text(
                                text = stringResource(Res.string.error_invalid_email),
                                color = MaterialTheme.colorScheme.error
                            )
                        }
                    }
                )
                if (uiState.error != null) {
                    Text(
                        text = stringResource(uiState.error),
                        color = MaterialTheme.colorScheme.error,
                        style = MaterialTheme.typography.bodySmall
                    )
                }
            }
        },
        confirmButton = {
            Button(
                onClick = onSendOtp,
                modifier = Modifier.testTag("sendOtpButton"),
                enabled = !uiState.isLoading && uiState.email.isNotBlank()
            ) {
                if (uiState.isLoading) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(16.dp),
                        color = MaterialTheme.colorScheme.onPrimary,
                        strokeWidth = 2.dp
                    )
                } else {
                    Text(stringResource(Res.string.send))
                }
            }
        },
        dismissButton = {
            TextButton(
                onClick = onDismiss,
                modifier = Modifier.testTag("cancelEmailDialogButton")
            ) {
                Text(stringResource(Res.string.cancel))
            }
        }
    )
}